namespace GeniuzPOS.InitialData {
    export interface PsRefundReasonRow {
        Id?: number;
        RefundId?: number;
        RefundReason?: string;
        Remark?: string;
        TaxRefundReasonId?: string;
        PurposeCode?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        RefundFg?: number;
    }

    export namespace PsRefundReasonRow {
        export const idProperty = 'RefundId';
        export const nameProperty = 'RefundReason';
        export const localTextPrefix = 'InitialData.PsRefundReason';
        export const lookupKey = 'InitialData.PsRefundReason';

        export function getLookup(): Q.Lookup<PsRefundReasonRow> {
            return Q.getLookup<PsRefundReasonRow>('InitialData.PsRefundReason');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เหตุผลการคืน:Modify';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เหตุผลการคืน:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เหตุผลการคืน:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เหตุผลการคืน:Modify';

        export declare const enum Fields {
            Id = "Id",
            RefundId = "RefundId",
            RefundReason = "RefundReason",
            Remark = "Remark",
            TaxRefundReasonId = "TaxRefundReasonId",
            PurposeCode = "PurposeCode",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            RefundFg = "RefundFg"
        }
    }
}
